/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
    TeamToJSONTyped,
} from './Team';

/**
 * 
 * @export
 * @interface PaginatedTeamList
 */
export interface PaginatedTeamList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTeamList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTeamList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTeamList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Team>}
     * @memberof PaginatedTeamList
     */
    results: Array<Team>;
}

/**
 * Check if a given object implements the PaginatedTeamList interface.
 */
export function instanceOfPaginatedTeamList(value: object): value is PaginatedTeamList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedTeamListFromJSON(json: any): PaginatedTeamList {
    return PaginatedTeamListFromJSONTyped(json, false);
}

export function PaginatedTeamListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedTeamList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(TeamFromJSON)),
    };
}

  export function PaginatedTeamListToJSON(json: any): PaginatedTeamList {
      return PaginatedTeamListToJSONTyped(json, false);
  }

  export function PaginatedTeamListToJSONTyped(value?: PaginatedTeamList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(TeamToJSON)),
    };
}

